import { addMinutes } from "date-fns";

export default function parseDate(date) {
  if (!date) return new Date()

  return addMinutes(date, new Date().getTimezoneOffset());
}